import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SigninGeneralService } from '../../shared/signinGeneral.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss'],
  standalone: false
})
export class ForgotComponent  {
  @Input() email = '';
  @Output() done: EventEmitter<boolean> = new EventEmitter();
  constructor(private generalService: SigninGeneralService) { }
  whileUpdating = false;

  onSend() {
    if (this.email !== '') {
      this.whileUpdating = true;
      this.generalService.sendPasswordReset('', this.email, '', true);
      setTimeout(() => {
        this.done.emit(true);
        this.whileUpdating = false;
      }, 4000);
    } else {
      this.done.emit(false);
    }
  }
}
